import { render, staticRenderFns } from "./costFeeList.vue?vue&type=template&id=ab0ce674"
import script from "./costFeeList.vue?vue&type=script&lang=js"
export * from "./costFeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports